import moment from 'moment';
import { createSlice } from '@reduxjs/toolkit';
import { catalog, objectId } from '../../apis/local/catalog';

const initialState = {
    isInitialized: false,
    isLoading: false,
    error: null,
    notifications: []
};

const Notifications = catalog('notifications');

const getSortedNotifications = () => {
    return [...Notifications.all()].sort((itemA, itemB) => (itemA.date < itemB.date ? 1 : -1));
};

export const uiSlice = createSlice({
    name: 'ui',
    initialState,
    reducers: {
        initialize: (state) => {
            state.isInitialized = true;
            state.isLoading = false;
            state.notifications = getSortedNotifications();
        },
        clearNotifications: (state) => {
            Notifications.all().forEach((notification) => Notifications.remove(notification.id));
            state.notifications = getSortedNotifications();
        },
        addNotification: (state, action) => {
            const { icon = 'bell', type = 'secondary', title, message } = action.payload;
            const date = moment(new Date()).format('YYYY/MM/DD HH:mm:ss');
            Notifications.add({
                id: objectId(),
                date,
                icon,
                type,
                title,
                message,
                read: false
            });
            state.notifications = getSortedNotifications();
        },
        markAsReadNotification: (state, action) => {
            const { id } = action.payload;
            const notification = Notifications.all().find((item) => item.id == id);
            Notifications.update(id, {
                ...notification,
                read: true
            });
            state.notifications = getSortedNotifications();
        },
        markAsReadAllNotifications: (state) => {
            for (const notification of Notifications.all()) {
                Notifications.update(notification.id, {
                    ...notification,
                    read: true
                });
            }
            state.notifications = getSortedNotifications();
        },
        removeNotification: (state, action) => {
            Notifications.remove(action.payload.id);
            state.notifications = getSortedNotifications();
        }
    }
});

// State
export const isInitialized = (state) => state.ui.isInitialized;
export const isLoading = (state) => state.ui.isLoading;
export const error = (state) => state.ui.error;
export const notifications = (state) => state.ui.notifications;

// Actions
export const {
    initialize,
    clearNotifications,
    addNotification,
    markAsReadNotification,
    markAsReadAllNotifications,
    removeNotification
} = uiSlice.actions;

// Reducer
export default uiSlice.reducer;
